import { PlayerName } from "@/components/PlayerCardDialog";
import React from "react";
import { CheckCircle2 } from "lucide-react";

// #91 / LEO CARLSSON / C • L1
export const PlayerChip = ({ jersey, name, team, position, line, verified, injury, testId }) => {
  return (
    <div
      data-testid={testId}
      className="group flex items-center gap-2.5 rounded-md border border-slate-800/80 bg-slate-900/50 px-2.5 py-1.5 transition-colors hover:border-cyan-800/70 hover:bg-slate-900"
    >
      <span className="font-mono text-sm font-bold text-cyan-400 tabular-nums w-9 text-right">
        {jersey != null ? `#${jersey}` : "#—"}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <span className="truncate text-[13px] font-semibold uppercase tracking-tight text-slate-100 font-display">
            <PlayerName name={name} team={team}>{name || "—"}</PlayerName>
          </span>
          {verified && <CheckCircle2 className="h-3 w-3 shrink-0 text-emerald-400" title="Verified vs official roster" />}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-1.5 font-mono text-[10px]">
        {position && (
          <span className="rounded bg-slate-800 px-1.5 py-0.5 font-semibold text-slate-300">{position}</span>
        )}
        {line && <span className="text-slate-500">{line}</span>}
        {injury && <span className="rounded bg-rose-950/70 px-1.5 py-0.5 font-semibold text-rose-400">{injury}</span>}
      </div>
    </div>
  );
};

export default PlayerChip;
